export default "__VITE_ASSET__8dbf5da5__"